import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export const list = async (data: any) => {
  return httpRequest.post(`/ord/order/split/list`, data)
}

export const excel = async (data: any) => {
  return httpRequest.post("/ord/order/split/excel", data)
}
